// extracted by mini-css-extract-plugin
export default {"title":"AdminAside_title__NkI-C","aside_nav_wrapper_list":"AdminAside_aside_nav_wrapper_list__Y3kFg"};